import React from 'react';
import { Folder } from 'lucide-react';
interface ProductSourceCardProps {
  collectionName: string;
  productCount: number;
  onChange: () => void;
  // Shows the "Set a quantity first" state instead
  isLocked?: boolean;
}

// The existing Product Source card, used on the pack and on each release
export function ProductSourceCard({
  collectionName,
  productCount,
  onChange,
  isLocked = false
}: ProductSourceCardProps) {
  if (isLocked) {
    return <div className="border border-dashed border-[#CBD5E1] rounded-lg p-4 flex items-center justify-between bg-[#F8FAFC]" data-id="element-4066" data-mp="hjv3u3urb54u">
        <div className="flex items-center gap-3" data-id="element-4067" data-mp="rc0vtdl0dmk1">
          <div className="w-10 h-10 rounded-lg bg-[#F1F5F9] flex items-center justify-center text-[#94A3B8]" data-id="element-4068" data-mp="rcal0yy8bpoo">
            <Folder className="w-5 h-5" data-id="element-4069" data-mp="wa2aznfbd1q8" />
          </div>
          <div data-id="element-4070" data-mp="10d8i0xa92wxr">
            <div className="text-[14px] font-medium text-[#94A3B8]" data-id="element-4071" data-mp="10drysao5zfa7">
              Set a quantity first
            </div>
            <div className="text-[13px] text-[#CBD5E1]" data-id="element-4072" data-mp="15btgos9ut8k3">
              Enter the number of bottles above to enable product selection
            </div>
          </div>
        </div>
        <span className="text-[13px] font-medium text-[#CBD5E1] cursor-not-allowed" data-id="element-4073" data-mp="2fq04rhu9yf6c">
          Change
        </span>
      </div>;
  }
  return <div className="border border-[#E2E8F0] rounded-lg p-4 flex items-center justify-between bg-white" data-id="element-4074" data-mp="2atjfgkbc9uro">
      <div className="flex items-center gap-3" data-id="element-4075" data-mp="25uybqawvosyh">
        <div className="w-10 h-10 rounded-lg bg-[#E0F2FE] flex items-center justify-center text-[#0EA5E9]" data-id="element-4076" data-mp="33fcd6fhs2j7l">
          <Folder className="w-5 h-5" data-id="element-4077" data-mp="2yily9vhpltnr" />
        </div>
        <div data-id="element-4078" data-mp="2tqauuinrfpqg">
          <div className="text-[14px] font-semibold text-[#0F172A]" data-id="element-4079" data-mp="2tq1771q6tunx">
            {collectionName}
          </div>
          <div className="text-[13px] text-[#64748B]" data-id="element-4080" data-mp="2oqg5wknjpa81">
            {productCount} products
          </div>
        </div>
      </div>
      <button type="button" className="text-[13px] font-medium text-[#0EA5E9] hover:text-[#0284C7] hover:underline" onClick={onChange} data-id="element-4081" data-mp="3m86h8edv4qx1">
        Change
      </button>
    </div>;
}